import type React from "react";
import { Text, type TextProps } from "tamagui";
import tamaguiConfig from "../../tamagui.config";
import { Input, type InputProps } from "./InputNew";
import { Skeleton } from "./Skeleton";

const labelStyle = {
  fontFamily: "$label",
  fontWeight: "bold",
  lineHeight: "$true",
  fontSize: "$true",
} as const;

export const Label = ({
  children,
  ...textProps
}: { children: React.ReactNode } & TextProps) => {
  return (
    <Text {...labelStyle} {...textProps}>
      {children}
    </Text>
  );
};

export const LabelTextarea: React.FC<
  InputProps & {
    muted?: boolean;
    strikeThrough?: boolean;
  }
> = ({ muted, strikeThrough, ...props }) => {
  return (
    <Input
      {...labelStyle}
      textDecorationLine={strikeThrough ? "line-through" : undefined}
      color={muted ? "$muted" : "$color"}
      {...props}
    />
  );
};

export const LabelSkeleton: React.FC = () => {
  const appConfig = tamaguiConfig;

  return (
    <Skeleton width={"100%"} height={appConfig.fonts.label.lineHeight.true} />
  );
};
